import { useItem } from "../../../fetch/fetch.item.ts";
import LoadingLine from "../../core/loading/LoadingLine.tsx";
import ErrMessage from "../../core/ErrMessage.tsx";
import { EMPTY_ITEM } from "../../../const/typeDefault/Item.ts";
import FilterUnit from "../../filter/core/FilterUnit";
import { useFilter } from "../../../fetch/fetch.filter";
import { EMPTY_FILTER } from "../../../const/typeDefault/Filter";
import { FILTER_DISPLAY } from "../../../types/Filter.ts";

const ItemPrimaryInfos = ({ itemId }: { itemId: string }) => {
  const { item, isLoading, isError } = useItem(itemId, EMPTY_ITEM);
  if (isLoading) return <LoadingLine description="..." />;
  if (isError) return <ErrMessage message={isError} />;
  return item.categoryData.map(({ filterId, value }, index) => (
    <ItemInfo
      filterId={filterId}
      value={String(value)}
      key={index + filterId}
    />
  ));
};
export default ItemPrimaryInfos;

const ItemInfo = ({ filterId, value }: { filterId: string; value: string }) => {
  const { filter, isLoading, isError } = useFilter(filterId, EMPTY_FILTER);
  if (!filter.required) return null;
  if (filter.display === FILTER_DISPLAY.SECONDARY) return;
  if (isLoading) return null;
  if (isError) return isError.message;
  return (
    <span key={filterId} className="flex opacity-80">
      <p className="flex-none">{value}</p>
      <FilterUnit id={filterId} />
    </span>
  );
};
